import { Card, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';

export const EmptyState = () => {
  const { t } = useTranslation();

  return (
    <Card
      variant="default"
      sx={{
        textAlign: 'center',
        borderRadius: 0,
      }}
    >
      <SearchIcon
        sx={{ fontSize: 40, color: 'var(--color-deep-ocean-blue)' }}
      />
      <Typography variant="body1">
        {t('publicSearch.tableDescription')}
      </Typography>
    </Card>
  );
};
